import Client from "@/repositories/Client/AxiosClient.js"

const resource = `/api/connection-groups`

export default {
  list() {
    return Client.get(`${resource}`)
  },
  create(name) {
    return Client.post(`${resource}`, name)
  },
  update(connectionGroup) {
    return Client.put(`${resource}/${connectionGroup.id}`, connectionGroup)
  },
}
